<template>
  <div class="opera-cityState">
    <topNav :title="$t('cityState_title')"></topNav>
    <div class="fangt_top">
      <div class="search">
        <i class="iconfont icon-sousuo"></i>
        <input type="text" id='searchInput' v-model='searchText' name="" :placeholder="$t('cityState_search_placeholder') ">
        <div class="cleartext" @click="searchText='';getcityrm();" v-show="searchText != ''">
          <i class="iconfont icon-cuowu"></i>
        </div>
      </div>
      <div class="searct_btn" @click='getcityrm'>{{$t('search')}}</div>
      <span class="line"></span>
      <router-link to='/opera/ConfigeHotel'>
        <div class="filter">{{$t('hotel')}}
          <i class="iconfont icon-menu1"></i>
        </div>
      </router-link>
    </div>
    <div class="hotelState">
      <div class="content" v-for="item in cityrm">
        <i class="iconfont icon-changfangxingbiaoqian"></i>
        <div class="h_title" @click='openDetail(item,this)' data-open="false" :class="{unfold:item.unfold==true}">
          {{item.name}}
          <i class="iconfont icon-xia"></i>
        </div>
        <div class="numberPhone">
          <span>
              <a :href='"tel:"+item.tel'>{{item.tel}}</a>
          </span>
        </div>
        <ul class="list clearfix">
          <li class="info twocol">
            <span>{{$t('index_homeData_angle_allNum')}}:</span>
            <span class="numberFont">{{item.total}}</span>
          </li>
          <li class="info twocol">
            <span>{{$t('index_homeData_angle_sort')}} :</span>
            <span class="numberFont">{{item.avl}}</span>
          </li>
          <li class="info twocol">
            <span>{{$t('index_homeData_angle_takeUp')}}:</span>
            <span class="numberFont">{{item.used}}</span>
          </li>
          <li class="info twocol">
            <span>{{$t('index_homeData_angle_maintenance')}}:</span>
            <span class="numberFont">{{item.oo}}</span>
          </li>
        </ul>
        <table class="rmtb" v-show="item.unfold==true">
          <tr class="rmhead">
            <th width="28%">{{$t('fangXQ_rmtype')}}</th>
            <th width="18%">{{$t('fangXQ_total_num')}}</th>
            <th width="18%">{{$t('fangXQ_available')}}</th>
            <th width="18%"> {{$t('fangXQ_takeup')}} </th>
            <th width="18%"> {{$t('fangXQ_maintenance')}} </th>
          </tr>
          <tr class="rmlist" v-for="itemD in item.detail">
            <td>{{itemD.roomType}}</td>
            <td>{{itemD.roomCount}}</td>
            <td>{{itemD.inLive}}</td>
            <td>{{itemD.inReservation}}</td>
            <td>{{itemD.inRemain}}</td>
          </tr>
        </table>
      </div>
      <nothing :condition="cityrm != null && (cityrm.length == undefined || cityrm.length == 0)"></nothing>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import {Toast, Checklist} from 'mint-ui';
  import nothing from '../operaCommon/nothing'

  export default {

    data() {
      return {
        filter: false,
        value: [],
        cityrm: null,
        searchText: '',
        checkOption: [],

      }
    },
    mounted() {
      this.getcityrm();
    },
    methods: {
      getcityrm() {
        this.$http.post('/mobilepmsapi/reception/getSameCityInfo', {searchText: this.searchText}).then(res => {
          if (res.data.result == 0) {
            this.cityrm = res.data.retVal;
            _.forEach(this.cityrm, (el, index) => {
              this.$set(el, 'unfold', false);
            })
          } else {
            this.msg(res.data.msg);
          }
        })
      },
      openDetail(item) {
        if (item.detail == null) {
          this.$http.post('/mobilepmsapi/reception/getRoomSituationDetail', {
            'bSum': false,
            'hotelCode': item.code,
            'hotelId': item.id,
          }).then(result => {
            item.detail = result.data.retVal;
            item.unfold = !item.unfold;
          });
        } else {
          item.unfold = !item.unfold;
        }
      },
      msg(msg) {
        Toast({
          message: msg,
          position: 'bottom',
          duration: 3000
        });
        return false;
      },
    },
    filters: {},
    components: {
      nothing
    }
  }
</script>
<style lang='less'>
  .opera-cityState {
    background-color: #F6F8F9;

    .fangt_top {
      height: 1.26666667rem;
      width: 10rem;
      background: #fff;
      padding: .18666667rem 0;
      box-sizing: border-box;
      position: absolute;
      z-index: 1001;

      .search {
        margin-left: .34666667rem;
        border-radius: .44rem;
        width: 5.73333333rem;
        float: left;
        height: 0.85333333rem;
        background-color: #f7f8fa;
        padding: 0 .26666667rem;
        overflow: hidden;
        box-sizing: border-box;

        i.icon-sousuo {
          vertical-align: bottom;
          font-size: 0.42666667rem;
          color: #ccc;
          line-height: .89333333rem;
        }

        input {
          padding-left: .2rem;
          width: 3.68rem;
          vertical-align: middle;
          margin-bottom: .13333rem;
          height: .62666667rem;
          background-color: #f7f8fa;
          outline: 0;
          border: 0;
        }

        .cleartext {
          float: right;

          i.icon-cuowu {
            line-height: 0.32rem;
            background-color: #c3c3c3;
            border-radius: 50%;
            font-size: 0.32rem;
            text-align: center;
            color: #fff;
            padding: 0.13333333rem;
            margin-top: 0.13333333rem;
            -webkit-transform-origin-x: 0;
            transform: scale(0.6);
            -webkit-transform: scale(0.6);
            width: 0.32rem;
            display: inline-block;
          }
        }
      }

      .searct_btn {
        width: 1.73333333rem;
        box-sizing: border-box;
        text-align: left;
        float: left;
        height: 100%;
        font-size: .32rem;
        line-height: .89333333rem;
        color: #5b5b5b;
        padding-left: .33333333rem;
      }

      .line {
        float: left;
        width: .02666667rem;
        height: .53333333rem;
        background-color: #ccc;
        margin-top: .21333333rem;
      }

      .filter {
        width: 1.86666667rem;
        float: left;
        font-size: .37333333rem;
        line-height: .89333333rem;
        text-align: right;
        box-sizing: border-box;
        color: #5b5b5b;

        .iconfont {
          display: inline-block;
          margin-left: .13333333rem;
          font-size: 12px;
        }
      }
    }

    .hotelState {
      margin: 1.60rem 0.26666667rem 0 0.26666667rem;
      overflow-y: auto;
      box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.1);
      height: 85%;

      .content {
        box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        margin-bottom: 10px;
        background: #fff;
        padding-bottom: 10px;
        position: relative;

        .icon-changfangxingbiaoqian {
          position: absolute;
          font-size: 12px;
          left: -4px;
          top: 15px;
          color: #f6a624;
          z-index: 1000;
        }

        .h_title {
          text-align: left;
          font-weight: bold;
          height: 27px;
          line-height: 27px;
          color: #000;
          padding: 8px 10px 0px 18px;

          &.unfold {

            .icon-xia {

              display: inline-block;
              transform: rotate(180deg);
            }
          }

          .icon-xia {
            float: right;
          }
        }

        .numberPhone {
          color: #999;
          padding-left: 18px;

          span {

            a {
              color: #999;
            }
          }
        }

        .list {
          padding: 14px;

          .info {
            width: 100%;
            float: left;
            color: #333;
            text-align: left;
            height: 20px;

            span {
              margin-left: 8px;
              display: block;
              text-align: center;
              margin-top: 6px;
              font-size: 12px;
              color: #999;
            }

            .numberFont {
              font-size: 24px;
              color: #000;
            }

            &.twocol {
              width: 25%;
              height: auto;
            }
          }
        }

        .rmtb {
          width: 96%;
          margin: 0 auto;

          .rmhead {
            color: #656565;
            background-color: #dddddd;
            height: 39px;

            th {
              font-weight: normal;
            }
          }

          .rmlist {
            text-align: center;
            height: 41px;

            &:nth-of-type(2n) {
              background-color: #f5f5f5;
            }
          }
        }
      }
    }

    .filterContent {
      position: fixed;
      top: 0px;
      height: 100vh;
      background-color: #fff;
      width: 100%;
      z-index: 1001;
      overflow: auto;

      .mint-checklist {
        padding-bottom: 45px;

        .mint-checklist-title {
          display: none;
        }

        .mint-cell {
          min-height: 40px;
          height: 40px;

          &:nth-of-type(2n) {
            background-color: #f5f5f5;
          }

          .mint-checkbox-core {
            border-radius: 0;
            height: 16px;
            width: 16px;
          }
        }

        .mint-checkbox-input:checked + .mint-checkbox-core {
          background-color: #fff;
          border-color: #ddd;
        }

        .mint-checkbox-input:checked + .mint-checkbox-core::after {
          border-color: #F89635;
        }

        .mint-checkbox-core::after {
          top: 2px;
          left: 5px;
        }

        .mint-checkbox-label {
          margin-left: 20px;
          font-size: 12px;
          color: #333;
        }

        .mint-cell-wrapper {
          background-image: none;
        }
      }

    }

    .staI {
      position: fixed;

      bottom: 0;
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 16px;
      line-height: 45px;
      height: 45px;
      background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

      .btn {
        float: left;
        width: 50%;
        text-align: center;
        color: #fff;
        height: 15px;
        font-size: 15px;
        line-height: 15px;
        margin-top: 15px;
        box-sizing: border-box;
        border-right: 1px solid rgba(255, 255, 255, 0.5);
      }
    }

    .cityState .topHeader .mint-header {
      z-index: 2000;
    }
  }

  .cityState .topHeader {
    z-index: 2001;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// cityState.vue?18ea9d10